export default __webpack_public_path__ + "static/media/spinner.bc73880a.svg";